import { ICarrierOutputDto } from './carrier-output-dto.interface';
import { IDeviceOutputDto } from './vehicle-output-dto.interface';
import { IVehicleOutputDto } from './vehicle-output-dto.interface';

export interface ISemitrailerDimensions {
    length?: number;
    width?: number;
    height?: number;
}

export interface ISemitrailerCapacity {
    tareWeight?: number;
    maxLoadWeight?: number;
    volume?: number;
}

export interface ISemitrailerCompartment {
    m3?: number;
    lts?: number;
}

export interface ISemitrailerOutputDto {
    id: string;
    organizationId?: string;
    externalId?: string;
    licensePlate: string;
    name?: string;
    vin?: string;
    make?: string;
    model?: string;
    year?: number;
    bodyType?: string;
    cargoType?: string;
    axles?: string;
    dimensions?: ISemitrailerDimensions;
    capacity?: ISemitrailerCapacity;
    compartments?: ISemitrailerCompartment[];
    brakeType?: string[];
    suspensionType?: string;
    tireType?: string;
    kingPin?: string;
    device?: IDeviceOutputDto;
    carrier?: string | ICarrierOutputDto;
    vehicleId?: string;
    vehicle?: string | IVehicleOutputDto;
    createdAt?: string;
    updatedAt?: string;
    isDeleted?: boolean;
    deletedAt?: string;
}
